var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidIdpPosteid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485.8 133.5",
    style: {
      enableBackground: "new 0 0 485.8 133.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0047BB;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#EDDB00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_PosteID_abilitato_SPID"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366,48.7h-2.7L345,22.3l-0.1,0v26.4h-2.7V17.9h2.7l18.3,26.3l0.1,0V17.9h2.7V48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.3,17.9v20.5c0,3.4-1.1,6-3.3,7.9c-2.2,1.9-5,2.9-8.4,2.9c-3.4,0-6.1-1-8.3-2.9c-2.1-1.9-3.2-4.6-3.2-7.9 V17.9h2.7v20.5c0,2.7,0.8,4.8,2.5,6.3c1.6,1.6,3.8,2.3,6.3,2.3c2.6,0,4.8-0.8,6.5-2.3c1.7-1.6,2.5-3.7,2.5-6.3V17.9H394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423,35.8c0,4-1.1,7.2-3.4,9.7c-2.3,2.5-5.4,3.7-9.2,3.7c-3.8,0-6.8-1.2-9.1-3.7c-2.3-2.5-3.4-5.7-3.4-9.7v-5 c0-4,1.1-7.2,3.4-9.7c2.2-2.5,5.3-3.7,9.1-3.7c3.8,0,6.9,1.2,9.2,3.7c2.3,2.5,3.4,5.7,3.4,9.7V35.8z M420.4,30.7 c0-3.3-0.9-6-2.7-8c-1.8-2-4.2-3.1-7.4-3.1c-3.1,0-5.5,1-7.2,3.1c-1.7,2-2.6,4.7-2.6,8v5.1c0,3.4,0.9,6.1,2.6,8.1 c1.7,2,4.1,3,7.2,3c3.2,0,5.6-1,7.4-3c1.8-2,2.6-4.7,2.6-8.1V30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.8,43.3l0.6,2.2h0.1l0.6-2.2l9.7-25.4h2.9l-12,30.8h-2.5l-12-30.8h2.9L435.8,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,35.8c0,4-1.1,7.2-3.4,9.7c-2.3,2.5-5.4,3.7-9.2,3.7c-3.8,0-6.8-1.2-9.1-3.7c-2.3-2.5-3.4-5.7-3.4-9.7 v-5c0-4,1.1-7.2,3.4-9.7c2.2-2.5,5.3-3.7,9.1-3.7c3.8,0,6.9,1.2,9.2,3.7c2.3,2.5,3.4,5.7,3.4,9.7V35.8z M472.6,30.7 c0-3.3-0.9-6-2.7-8c-1.8-2-4.2-3.1-7.4-3.1c-3.1,0-5.5,1-7.2,3.1c-1.7,2-2.6,4.7-2.6,8v5.1c0,3.4,0.9,6.1,2.6,8.1 c1.7,2,4.1,3,7.2,3c3.2,0,5.6-1,7.4-3c1.8-2,2.6-4.7,2.6-8.1V30.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.4,72.3h-5.1l-1,3.2h-4.2l5.6-16.4h2.1v0l0,0h2.1l5.6,16.4h-4.2L354.4,72.3z M350.2,69.4h3.3l-1.6-5.1 h-0.1L350.2,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.9,75.5V59.1h5.6c2.1,0,3.8,0.4,5,1.1c1.2,0.8,1.8,1.9,1.8,3.4c0,0.8-0.2,1.5-0.6,2.1 c-0.4,0.6-1,1.1-1.8,1.4c1,0.2,1.8,0.6,2.3,1.3c0.5,0.7,0.7,1.4,0.7,2.3c0,1.6-0.6,2.8-1.7,3.6c-1.1,0.8-2.7,1.2-4.9,1.2H360.9z  M364.9,65.9h1.6c1,0,1.7-0.2,2.2-0.5c0.5-0.3,0.7-0.8,0.7-1.4c0-0.7-0.2-1.2-0.7-1.5c-0.5-0.3-1.2-0.5-2.1-0.5h-1.6V65.9z  M364.9,68.5v4.1h2.6c0.9,0,1.5-0.2,1.9-0.5c0.4-0.3,0.6-0.8,0.6-1.5c0-0.7-0.2-1.2-0.6-1.6c-0.4-0.4-1-0.6-1.9-0.6h-0.1H364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.6,75.5h-4V59.1h4V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.6,72.6h7.4v2.9h-11.4V59.1h4V72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.3,75.5h-4V59.1h4V75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,62h-4.6v13.5h-4V62h-4.5v-2.9h13V62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.3,72.3h-5.1l-1,3.2H415l5.6-16.4h2.1v0l0,0h2.1l5.6,16.4h-4.2L425.3,72.3z M421.1,69.4h3.3l-1.6-5.1 h-0.1L421.1,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.7,62h-4.6v13.5h-4V62h-4.5v-2.9h13V62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.3,68.8c0,2-0.7,3.7-2,5c-1.3,1.3-3.1,2-5.3,2c-2.2,0-4-0.7-5.3-2c-1.4-1.3-2-3-2-5v-3c0-2,0.7-3.7,2-5 c1.4-1.3,3.1-2,5.3-2c2.2,0,3.9,0.7,5.3,2c1.4,1.3,2,3,2,5V68.8z M454.3,65.8c0-1.2-0.3-2.1-0.9-2.9c-0.6-0.8-1.4-1.1-2.5-1.1 c-1.1,0-1.9,0.4-2.5,1.1c-0.6,0.7-0.9,1.7-0.9,2.9v3c0,1.2,0.3,2.2,0.9,2.9c0.6,0.8,1.4,1.1,2.5,1.1c1,0,1.9-0.4,2.4-1.1 c0.6-0.8,0.9-1.7,0.9-2.9V65.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_Spid_Ufficiale"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M369.6,93.6c-5.8-0.7-9.9-1.1-12.2-1.1c-2.3,0-3.8,0.2-4.5,0.6c-0.7,0.4-1,1-1,1.9 c0,0.9,0.5,1.5,1.4,1.8c0.9,0.3,3.2,0.8,7,1.5c3.8,0.6,6.4,1.7,8,3.2c1.6,1.5,2.4,3.9,2.4,7.2c0,7.2-4.7,10.8-14.1,10.8 c-3.1,0-6.8-0.4-11.2-1.2l-2.2-0.4l0.3-7.5c5.8,0.7,9.8,1.1,12.1,1.1c2.3,0,3.8-0.2,4.6-0.6c0.8-0.4,1.2-1.1,1.2-1.9 c0-0.8-0.4-1.5-1.3-1.9c-0.9-0.4-3.1-0.9-6.7-1.5c-3.6-0.6-6.3-1.6-8.1-2.9c-1.8-1.4-2.7-3.8-2.7-7.4c0-3.5,1.3-6.2,3.8-8 c2.5-1.8,5.8-2.7,9.7-2.7c2.8,0,6.5,0.4,11.3,1.3l2.3,0.4L369.6,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393,92.5c-1.7,0-3.5,0.3-5.3,1l-0.8,0.3v17.5c2.1,0.3,3.8,0.4,5.1,0.4c2.7,0,4.6-0.8,5.6-2.3 c1-1.5,1.5-4.1,1.5-7.8C399.1,95.6,397.1,92.5,393,92.5 M377.5,132.8V85.3h9.3v1.8c3-1.7,5.7-2.6,8-2.6c4.7,0,8.2,1.4,10.4,4.1 c2.2,2.7,3.4,7.3,3.4,13.8c0,6.5-1.2,11-3.7,13.5c-2.5,2.5-6.5,3.8-12.2,3.8c-1.5,0-3.2-0.1-5-0.4l-0.8-0.1v13.8H377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.5,110.7l1-0.2V92.9c-2.6-0.4-4.9-0.7-6.9-0.7c-3.8,0-5.7,3.2-5.7,9.6c0,3.5,0.4,6,1.3,7.4 c0.8,1.5,2.2,2.2,4.2,2.2C458.3,111.5,460.4,111.2,462.5,110.7 M472.9,71.9v46.9h-9.3v-1.4c-3.3,1.5-6.1,2.2-8.5,2.2 c-5.1,0-8.6-1.4-10.7-4.2c-2-2.8-3-7.3-3-13.4c0-6.1,1.2-10.5,3.6-13.3c2.4-2.8,6-4.2,10.9-4.2c1.5,0,3.6,0.2,6.2,0.7l1.3,0.3 V71.9H472.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M425,104.7c-2.9,0-5.3-0.9-7.1-2.8c-1.9-1.9-2.8-4.2-2.8-6.9c0-2.8,0.9-5.1,2.8-6.9 c1.9-1.8,4.2-2.7,7.1-2.7c2.9,0,5.2,0.9,7.1,2.8c1.8,1.9,2.7,4.2,2.7,6.9c0,2.8-0.9,5-2.7,6.9C430.2,103.8,427.9,104.7,425,104.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M415.1,118.3c0-2.8,0.9-5.1,2.8-6.9c1.9-1.8,4.2-2.7,7.1-2.7c2.9,0,5.2,0.9,7.1,2.8 c1.8,1.9,2.7,4.2,2.7,6.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_PosteID_ufficiale"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_14_",
    className: "st1",
    width: 219.4,
    height: 133.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_13_",
    x: 199.9,
    className: "st2",
    width: 133.5,
    height: 133.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,85.9v-44h20.2c10.8,0,17.9,3.5,17.9,14.1s-7.1,14.1-17.9,14.1h-8v15.7H24.5z M42.9,61.6 c4.8-0.2,6.8-2.4,6.8-5.6c0-3.2-2-5.4-6.8-5.6h-6.3v11.2H42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.6,70.6c0,11.3-8.2,16.2-17.8,16.2S63,81.9,63,70.6c0-11.3,8.2-16.2,17.8-16.2S98.6,59.3,98.6,70.6  M80.8,80.1c4.9,0,5.9-5.2,5.9-9.5c0-4.3-1-9.5-5.9-9.5c-4.9,0-5.9,5.2-5.9,9.5C74.8,74.9,75.9,80.1,80.8,80.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M118.8,64.7c0-1-0.2-2-0.7-2.6c-0.6-0.7-1.6-1.1-3.2-1.1c-1.7,0-2.7,1-2.7,2.7 c0,2.3,4.7,2.1,11.9,4.4c3.7,1.2,6.2,3.4,6.2,8.4c0,8.1-7.6,10.2-14.6,10.2c-7.5,0-14.8-1.5-14.8-10.9h11c-0.2,0.9,0.1,2,0.8,2.7 c0.7,0.8,1.6,1.4,2.7,1.4c2.3,0,3.9-0.9,3.9-2.8c0-5.4-18.1-2.2-18.1-13.3c0-7.6,8.1-9.6,14.1-9.6c7.3,0,14,1.9,14.4,10.4H118.8z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M137.9,55.3v-4.6l11.6-4.4v9h6.7v7.3h-6.7v12.1c0,0.8-0.5,4.8,2.2,4.8c1.5,0,3.1,0,4.5-0.2 v6.9c-2.6,0.5-4.5,0.6-6.2,0.6c-7.9,0-12.6-1.1-12-10.5V62.6h-6v-7.3H137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.6,72.9c-0.1,4,1,7.4,5.3,7.4c3.2,0,5.2-1.5,5.7-4.4h10.7c-0.4,4-2.9,6.8-5.8,8.5 c-2.7,1.7-6.1,2.4-9.7,2.4c-12.2,0-17.1-5.2-17.1-17.3c0-9.7,7.3-15.2,16.5-15.2c12.4,0,16.4,7.1,16.4,18.5H169.6z M180.6,66.7 c0-1.6-0.5-3.3-1.4-4.6c-0.9-1.3-2.3-2.1-4-2c-4,0.2-5,3.1-5.3,6.5H180.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st0",
    points: "0,133.5 199.9,133.5 199.9,122.1 11.4,122.1 11.4,11.4 199.9,11.4 199.9,0 0,0  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.4,97.4V33.8h12.4v63.6H230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,91.4c-4.2,4.2-10.2,6.1-16.8,6.1h-23V33.8h23c6.6,0,12.6,1.9,16.8,6.1c7.1,7.1,6.4,15.9,6.4,25.5 C303.8,74.9,304.5,84.2,297.4,91.4z M288.7,48.9c-2.1-2.6-5-3.9-9.3-3.9h-9.4v41.4h9.4c4.3,0,7.1-1.3,9.3-3.9 c2.3-2.9,2.7-7.4,2.7-17.1S291,51.7,288.7,48.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIdpPosteid);
export default __webpack_public_path__ + "static/media/spid-idp-posteid.c7b0364341f9a5d2595bbc08814c230c.svg";
export { ForwardRef as ReactComponent };